/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "../actions/actionTypes";

// initialState
const initialState = {
  replayCoordinates: [],
};

/**
 * Capture actions dispatched and modify state accordingly
 * @param {*} state -> updated state
 * @param {*} action -> type of action dispatched
 */
const replayCoordinate = (state = initialState, action) => {
  switch (action.type) {
    // set replay coordinate in set
    case actionTypes.SET_COORDINATE:
      return {
        replayCoordinates: action.coordinates,
      };

    default:
      return state;
  }
};

export default replayCoordinate;
